import angular from 'angular';

(function () {
    'use strict';

    angular.module('app').factory('ModalService', ModalService);

    ModalService.$inject = ['$uibModal'];

    function ModalService($uibModal) {
        const service = {
            // list_modal: list_modal,
            // email_modal: email_modal,
            form_modal: form_modal,
            reschedule_modal: reschedule_modal,
            hour_picker_modal: hour_picker_modal,
            regular_class_modal: regular_class_modal,
            teacher_modal: teacher_modal,
        };

        return service;

        /** NO LIST MODAL IN APP/SHARED/MODAL */
        // function list_modal(form, modal, callback) {
        //     var modalInstance = $uibModal
        //         .open({
        //             component: 'listModal',
        //             size: 'md',
        //             backdrop: true,
        //             resolve: {
        //                 form: function() {
        //                     return form;
        //                 },
        //                 modal: function() {
        //                     return modal;
        //                 }
        //             }
        //         })
        //         .result.then(function(data) {
        //             if (data) {
        //                 callback(data);
        //             }
        //         });
        // }

        function form_modal(request, modal, component_template, size, classes) {
            var modalInstance = $uibModal.open({
                component: component_template || '',
                // controllerAs: 'vm',
                size: size || 'md',
                windowClass: classes || '',
                keyboard: !modal.ignoreKeyboard,
                backdrop: 'static',
                resolve: {
                    Request: function () {
                        return request;
                    },
                    Modal: function () {
                        return modal;
                    }
                }
            });

            return modalInstance.result;
        }


        /** NO INVITATION MODAL IN APP/SHARED/MODALS */
        // function email_modal(data, callback) {
        //     var modalInstance = $uibModal
        //         .open({
        //             templateUrl:
        //                 'app/shared/modals/invitation-modal/invitation-modal.html',
        //             controller: 'InvitationCtrl',
        //             controllerAs: 'vm',
        //             size: 'sm',
        //             backdrop: true,
        //             resolve: {
        //                 Data: function() {
        //                     return data;
        //                 }
        //             }
        //         })
        //         .result.then(function(data) {
        //             if (data) {
        //                 return callback(data);
        //             }
        //         });
        // }


        function hour_picker_modal(options) {
            // Open a ui bootstrap modal
            var modalInstance = $uibModal.open({
                component: 'hourPickerModal',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return options;
                    }
                }
            });

            // This is a promise
            return modalInstance.result;
        }

        function regular_class_modal(options) {
            // Open a ui bootstrap modal
            var modalInstance = $uibModal.open({
                component: 'regularClassModal',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return options;
                    }
                }
            });

            // This is a promise
            return modalInstance.result;
        }

        function teacher_modal(options) {
            // Open a ui bootstrap modal
            var modalInstance = $uibModal.open({
                component: 'teacherPickerModal',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return options;
                    }
                }
            });

            // This is a promise
            return modalInstance.result;
        }

        function reschedule_modal(options) {
            // Open a ui bootstrap modal
            var modalInstance = $uibModal.open({
                component: 'rescheduleModal',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return options;
                    }
                }
            });

            // This is a promise
            return modalInstance.result;
        }
    }
})();



// WEBPACK FOOTER //
// ./src/app/services/modal.service.js